module.exports = __webpack_public_path__ + "img/appBar.956a2848.png";